import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DataFeedRoutes } from '../routesHelper';

type DiscardDataFeedFormButtonProps = {
  onCancel?: () => void;
};

export const DiscardDataFeedFormButton = ({
  onCancel,
}: DiscardDataFeedFormButtonProps = {}) => {
  const { idTeam } = useParams<{ idTeam: string }>();
  const [isOpen, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleModal = () => {
    setOpen(!isOpen);
  };

  const handleOk = () => {
    setOpen(false);
    if (onCancel) {
      onCancel();
    } else {
      navigate(`${DataFeedRoutes.DataFeed}/${idTeam}`);
    }
  };

  return (
    <>
      <Button type="default" onClick={toggleModal}>
        Cancel
      </Button>
      <Modal
        open={isOpen}
        title="Unsaved Changes"
        onOk={handleOk}
        onCancel={toggleModal}
      >
        <p>You have unsaved changes on this page. Do you wish to continue?</p>
      </Modal>
    </>
  );
};
